const loggedInUser = state => state.loggedInUser;

const apiKey = state => state.loggedInUser.api_key;


export default {
  loggedInUser,
  apiKey
}